import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import BasicInformation from "./BasicInformation";
import { SignUpAPI, WeighmentSitesAPI } from "api";
import { customSettings } from "utils/customConfig";
import { toast } from "react-toastify";
import PageTitle from "utils/PageTitle";

const schema = yup
  .object({
    code: yup.string(),
    name: yup.string().required("Name is required"),
    // group: yup.string(),
    // streetAddress: yup.string(),
    // city: yup.string(),
    // state: yup.string(),
    // postalCode: yup.string(),
    // country: yup.string(),
    // contactNumber: yup.string(),
    // email: yup.string(),
  })
  .required();

const AddSite = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {},
  });
  const { handleSubmit, reset, setValue } = methods;

  const onSubmit = async (data) => {
    let myData = {
      ...data,
      id: location?.state?.id ?? 0, // Use nullish coalescing to handle undefined or null
    };

    // console.log(myData);

    try {
      if (location?.state) {
        setLoading(true);
        await WeighmentSitesAPI.post(myData);
        setLoading(false);
        toast.success("Weighment Site Updated Successfully", {
          position: customSettings.toastPosition,
          autoClose: customSettings.toastClose,
        });
      } else {
        setLoading(true);
        await WeighmentSitesAPI.post(myData);
        setLoading(false);
        toast.success("Weighment Site Created Successfully", {
          position: customSettings.toastPosition,
          autoClose: customSettings.toastClose,
        });
      }

      // ------- Get all object keys form data and set empty values to reset ------------
      const keys = Object.keys(data);
      for (const key of keys) {
        submittedValues[key] = "";
      }
      reset({ ...submittedValues });
      navigate(-1);
    } catch (error) {
      toast.error("Something Went Wrong", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });
      console.log(error);
    }
  };

  useEffect(() => {
    if (location?.state) {
      reset(location.state);
    }
  }, [setValue]);

  return (
    <>
      <PageTitle name="Libraries | Weighment Sites" />
      {/* <div className="py-2">
        <BreadCrumb />
      </div> */}
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Card>
            <Card.Header className="border-bottom">
              <Row className="flex-between-center ">
                <Col md>
                  <h5 className="fs-9 text-nowrap mb-2 mb-md-0">
                    {" "}
                    Libraries | Weighment Sites
                  </h5>
                </Col>
                <Col xs="auto">
                  <Button
                    variant="link"
                    className="text-secondary fw-medium p-0 me-3"
                    type="button"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit" disabled={loading}>
                    Ok
                  </Button>
                </Col>
              </Row>
            </Card.Header>
            <BasicInformation />
          </Card>
        </Form>
      </FormProvider>
    </>
  );
};

export default AddSite;
